<template>
  <div
    class="numberOne numberOne1 numberOne--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`NumberOne1-${pageUid}`">
    <div class="container margin-auto-inline">
      <div class="inner flex-column flex-center flex-middle">
        <div class="illustration">
          <img v-bind="image" v-show="image.show" />
        </div>
        <div
          class="number-one-jumbotron flex-center flex-middle margin-auto-horizontal text-center"
          :class="`bg-${titleBackgroundColor} c-${titleColor}`"
          v-if="isNonEmptyString(title)">
          <span :class="`c-${titleColor}`" class="text-bold text-center">
            {{ title }}
          </span>
        </div>
        <div
          class="type-info c-alt text-center"
          v-if="isNonEmptyString(subTitle)">
          <p :class="`c-${titleBackgroundColor}`">
            {{ subTitle }}
          </p>
        </div>
        <div class="achievements width-expand margin-2xl-bottom">
          <div
            class="achievement text-center c-alt"
            v-for="item of items"
            :class="`c-${itemColor}`">
            <span class="text1 bold">{{ item.text1 }}</span>
            <span v-if="isNonEmptyString(item.text2)">&nbsp;</span>
            <span v-if="isNonEmptyString(item.text2)" class="text2">{{ item.text2 }}</span>
          </div>
        </div>
        <div
          class="number-1-legal max-width-500 text-center"
          v-if="isNonEmptyString(legalText) || legalLink.show">
          <p :class="`c-${legalTextColor}`">
            {{ legalText }}
            <span v-if="legalLink.show"
              >&nbsp;<a
                v-bind="legalLink"
                @click.prevent="legalLink.navigationHandler">
                {{ legalLink.text }}
              </a></span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      image: {},
      title: "",
      subTitle: "",
      items: [
        {
          text1: "",
          text2: "",
        },
      ],
      legalText: "",
      legalLink: {},
      backgroundColor: "",
      titleBackgroundColor: "",
      titleColor: "",
      itemColor: "",
      itemBorderColor: "",
      legalTextColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {
    itemBorderBottomProperty() {
      return `3px dashed var(--c-${this.itemBorderColor})`;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.numberOne1 {
  .illustration {
    @media (max-width: 1024px) {
      height: 65px;
      width: auto;

      img {
        max-height: 100%;
        width: auto;
        max-width: 100%;
      }
    }
  }

  .type-info {
    margin-bottom: var(--margin-xl);

    p,
    span {
      font-size: var(--font-3xl);
      margin: 0;
      @media (max-width: 1024px) {
        font-size: var(--font-xl);
      }
    }
  }

  .number-one-jumbotron {
    padding: var(--margin-m) var(--margin-2xl);
    margin-top: var(--margin-xl);
    margin-bottom: var(--margin-m);
    border-radius: var(--border-radius-m);

    @media (max-width: 1024px) {
      padding: var(--margin-m) var(--margin-xl);
      margin-top: var(--margin-l);
      margin-bottom: var(--margin-m);
      border-radius: var(--border-radius-s);
    }

    span {
      font-size: var(--font-max);

      @media (max-width: 1024px) {
        font-size: var(--font-xl);
      }
    }
  }

  .achievements {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--margin-xl);
    font-size: var(--text-xl);

    @media (max-width: 1024px) {
      font-size: var(--text-l);
    }

    // notice: smaller than M not L!
    @media (max-width: 1024px) {
      gap: var(--margin-m);
    }
  }

  .achievement {
    padding: 0 var(--margin-l) var(--margin-m) var(--margin-l);
    border-bottom: v-bind(itemBorderBottomProperty);
    flex: 0 0 auto;
    font-size: var(--font-xl);

    @media (max-width: 1024px) {
      .text2 {
        font-weight: normal;
      }
    }

    @media (max-width: 1024px) {
      flex: auto;
      max-width: 320px;
      flex-shrink: 10;
      flex-grow: 0;
      font-size: var(--font-l);
      margin-inline-end: var(--margin-s);
      margin-inline-start: var(--margin-x);
    }

    @media (max-width: 1024px) {
      flex: 280px;
      flex-shrink: 10;
      flex-grow: 0;
      margin-inline-end: 0;
      margin-inline-start: 0;
    }
  }

  .number-1-legal {
    p {
      font-size: var(--font-xs);
      margin: 0;
    }

    p + p {
      margin-top: var(--margin-m);
    }
  }
}
</style>
